import React from "react";
import Marquee from "react-fast-marquee";
import m3mFoundationLogo from '../Img/m3m-Foundation-logo.png'
import maisLogo from '../Img/mais-logo.png'
import ekamLogo from '../Img/ekam-logo.png'
import chaasniLogo from '../Img/chaasni-logo.png'
import sleepwellLogo from '../Img/sleepwell-logo.png'
import blinkitLogo from '../Img/blinkit-logo.png'

const bankLogos = [
  m3mFoundationLogo,
  maisLogo,
  ekamLogo,
  chaasniLogo,
  sleepwellLogo,
  blinkitLogo
];

const Associates = () => {
  return (
    <div className="loan-card-main" style={{ overflowX: "hidden", maxWidth: "100%", margin: "0 auto" }}>
      <h2 className="sections-title-smco">
        <span className="horizontal-line"></span>Our Valueable Clients
      </h2>

      <p className="sections-description-smco">
        Ora Group proudly works with trusted dealers and distributors across India to deliver eco-friendly electric vehicles efficiently.
      </p>

      {/* Wrapper to limit width and prevent overflow */}
      <div style={{ overflowX: "hidden", maxWidth: "100%", margin: "0 auto" }}>
        <Marquee
          gradient={false}
          speed={40}
          pauseOnHover={true}
          className="bank-marquee"
        >
          {bankLogos.map((src, idx) => (
            <div key={idx} style={{ margin: "0 2rem", flexShrink: 0 }}>
              <img
                src={src}
                alt={`bank-${idx}`}
                style={{
                  maxWidth: "150px",
                  maxHeight: "60px",
                  objectFit: "contain",
                  filter: "grayscale(100%)",
                  transition: "filter 0.3s ease",
                }}
                onMouseOver={e => (e.currentTarget.style.filter = "none")}
                onMouseOut={e => (e.currentTarget.style.filter = "grayscale(100%)")}
              />
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default Associates;
